import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useMutation } from "react-relay";

import { useLockSlots } from "@/features/LockSlots";

import { BookingWizardDataAtom } from "../../atoms/stores";
import {
  CreateLessonBookingInput,
  useCreateDraftLessonBookingMutation,
} from "./__generated__/useCreateDraftLessonBookingMutation.graphql";

export const useCreateDraftLessonBooking = () => {
  const [createNewMultiSlotBooking, isCreating] =
    useMutation<useCreateDraftLessonBookingMutation>(
      useCreateDraftLessonBookingMutationString
    );

  const [lockSlots] = useLockSlots();

  const bookingWizardData = useAtomValue(BookingWizardDataAtom);

  const handleCreateDraftLessonBooking = (
    input: CreateLessonBookingInput,
    onComplete: (bookingId: string) => void
  ) => {
    const timeSlotIds =
      bookingWizardData?.type === "LessonBooking"
        ? bookingWizardData?.allLessonStartSlotIds ?? []
        : [input.startSlotId];
    lockSlots(
      {
        timeSlotIds,
      },
      () => {
        createNewMultiSlotBooking({
          variables: { input },
          onCompleted: (res) => {
            if (res?.responsePayload?.success) {
              const bookingId = res?.responsePayload?.booking?.id ?? "";

              if (bookingId) {
                onComplete(bookingId);
              }
            }
          },
        });
      }
    );
  };

  return [handleCreateDraftLessonBooking, isCreating] as const;
};

const useCreateDraftLessonBookingMutationString = graphql`
  mutation useCreateDraftLessonBookingMutation(
    $input: CreateLessonBookingInput!
  ) {
    responsePayload: createLessonBooking(input: $input) {
      errors {
        field
        code
        message
      }
      success
      booking {
        id
        ... on LessonBooking {
          status
          orders {
            edges {
              node {
                status
                total
                totalTaxes
                serviceCharges {
                  edges {
                    node {
                      amount
                    }
                  }
                }
                lineItemGroups {
                  lineItems {
                    name
                    total
                    type
                  }
                }
              }
            }
          }
        }
        rounds {
          edges {
            node {
              player {
                id
                fullName
              }
            }
          }
        }
      }
    }
  }
`;
